import React from 'react';
import { AcceptedProps } from './interface/accepted-props';
const NotFound: React.FC<AcceptedProps> = (props) => {
  return <div>Component Not Found ({props.inputConfig.type})</div>
}

export default NotFound;